import { defineComponent as _defineComponent } from 'vue'
import { FormatUtils } from '@/infra/utils/format.utils';



export default /*#__PURE__*/_defineComponent({
  __name: 'ExpiresCard',
  props: {
    expiresAt: { type: [Date, null], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();




const __returned__ = { get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})